import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";

/** Sube un documento de la empresa. Va en base64, igual que la carga manual. */
export function useUploadCompanyDocument() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      organizationId: string;
      fileName: string;
      base64Data: string;
    }) =>
      fetchToBackend("/admin/company-documents", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}

/** Activa o desactiva un documento. No se borra: explica veredictos viejos. */
export function useSetCompanyDocumentStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ documentId, status }: { documentId: number; status: boolean }) =>
      fetchToBackend(`/admin/company-documents/${documentId}/status`, {
        method: "PUT",
        body: JSON.stringify({ status }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}

/** Lee con IA los documentos que estén pendientes. */
export function useExtractCompanyDocuments() {
  const qc = useQueryClient();
  return useMutation({
    // `all` vuelve a extraer también lo ya procesado: es para cuando cambia el
    // prompt y lo guardado se queda corto.
    mutationFn: ({
      organizationId,
      all = false,
    }: {
      organizationId: string;
      all?: boolean;
    }) =>
      fetchToBackend(`/admin/company-documents/${organizationId}/extract`, {
        method: "POST",
        body: JSON.stringify({ all }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: workAdvisoryKeys.all }),
  });
}
